$(function() {
  return $(document).on('change', '#product_sale_iva, #product_sale_ico', function() {
    calculateSalePrice()
  })
})

$(function() {
  return $(document).on('keyup', '#product_sale_price', function() {
    calculateSalePrice()
  })
})

function calculateSalePrice() {
  iva = parseFloat($('#product_sale_iva').val())
  ico = parseFloat($('#product_sale_ico').val())
  salePrice = parseFloat($('#product_sale_price').val())
  priceProduct = salePrice / (1 + ((iva + ico) / 100))
  $('#product_product_price').val(priceProduct)
}